<div class="rec-container ">
  <h2>Search Recorded Land Plans by</h2>
  <form (ngSubmit)="onSubmit($event)" #f="ngForm">

    <div class="name-role-container mb-55">
      <div class="name-container">
        <app-name></app-name>
      </div>
      <div class="role-container">
        <div class="space"></div>
        <app-planrole></app-planrole>
      </div>
    </div>
    <div class="date-container">
      <!--<app-daterange></app-daterange>-->
      <lib-date-range-parent></lib-date-range-parent>
    </div>
    <div class="city-container">
      <app-city-town-ex></app-city-town-ex>
    </div>
    <div>
      Plans recorded in Deeds Books (Deed Books 1 - 246) must be searched for in the Land Record 1962 to NOW search.<br /><br />
      Plans with a recorded date of 1/1/1840 have an indeterminate recording date at this time.
    </div>
    <button class="btn btn-default" type="submit">
      SEARCH
    </button>
  </form>
</div>
